import TurfProRobotStatus = ToroEnums.TurfProRobotStatus;

import { Component, Input } from '@angular/core';
import { ToroEnums } from '../../../../../common/enumerations/toro.enums';
import { TurfProRobot } from '../../../../../api/turf-pro/models/turf-pro-robot.type';

@Component({
    selector: 'toro-turf-pro-asset-card',
    templateUrl: './turf-pro-asset-card.component.html',
    styleUrls: ['./turf-pro-asset-card.component.less']
})
export class TurfProAssetCardComponent {
    protected readonly imagePath: string = '/assets/images/turf-pro/'
    protected readonly Math = Math;

    private _asset: TurfProRobot;
    @Input() set asset(value: TurfProRobot) {
        if (value == null) { return; }

        this._asset = value;
        this.setComponentData();
    }

    get asset(): TurfProRobot {
        return this._asset;
    }

    protected onlineStatusImgUri: string;
    protected pillAndBorderColor: string = 'grey';
    protected pillText: string = '';
    protected mowerImage: string = '';

    // =========================================================================================================================================================
    // Ctor and Lifecycle Hooks
    // =========================================================================================================================================================

    constructor() { }

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================

    private setComponentData(): void {
        // this.onlineStatusImgUri = this.asset?.isOnline ? '/assets/images/turf-pro/turf-pro-online.svg' : '/assets/images/turf-pro/turf-pro-offline.svg';
        this.onlineStatusImgUri = '/assets/images/turf-pro/turf-pro-online.svg'

        switch (this.asset?.robotStatus) {
            case TurfProRobotStatus.Unknown:
                this.pillAndBorderColor = '#33393D';
                this.pillText = 'STRINGS.UNKNOWN';
                break;
            case TurfProRobotStatus.Off:
                this.pillAndBorderColor = '#33393D';
                this.pillText = 'STRINGS.OFF';
                break;
            case TurfProRobotStatus.OffAfterAlarm:
                this.pillAndBorderColor = '#B55858';
                this.pillText = 'STRINGS.OFF_AFTER_ALARM';
                break;
            case TurfProRobotStatus.Idle:
                this.pillAndBorderColor = '#B4B4B4';
                this.pillText = 'STRINGS.STAYING';
                break;
            case TurfProRobotStatus.Alarm:
                this.pillAndBorderColor = '#EF3233';
                this.pillText = 'STRINGS.ALARM';
                break;
            case TurfProRobotStatus.Work:
                this.pillAndBorderColor = '#007866';
                this.pillText = 'STRINGS.WORK_IN_PROGRESS';
                break;
            case TurfProRobotStatus.GoChargeStation:
                this.pillAndBorderColor = '#66A897';
                this.pillText = 'STRINGS.HEADING_CHARGING_STATION';
                break;
            case TurfProRobotStatus.GoUnloadStation:
                this.pillAndBorderColor = '#66A897';
                this.pillText = 'STRINGS.HEADING_UNLOAD_STATION';
                break;
            case TurfProRobotStatus.LeaveStation:
                this.pillAndBorderColor = '#66A897';
                this.pillText = 'STRINGS.LEAVING_STATION';
                break;
            case TurfProRobotStatus.Charge:
                this.pillAndBorderColor = '#207DEF';
                this.pillText = 'STRINGS.CHARGING';
                break;
            case TurfProRobotStatus.WaitStation:
                this.pillAndBorderColor = '#8FBAD7';
                this.pillText = 'STRINGS.WAITING_AT_STATION';
                break;
            case TurfProRobotStatus.Border:
                this.pillAndBorderColor = '#66A897';
                this.pillText = 'STRINGS.BORDER';
                break;
            case TurfProRobotStatus.Service:
                this.pillAndBorderColor = '#B4B4B4';
                this.pillText = 'STRINGS.SERVICE';
                break;
            case TurfProRobotStatus.GoToPOI:
                this.pillAndBorderColor = '#66A897';
                this.pillText = 'STRINGS.HEADING_TO_POI';
                break;
        }

        switch (this.asset?.robotModel) {
            case 'Turf Pro 300':
                this.mowerImage = 'tp-turf-pro-300.png';
                break;

            case 'Turf Pro 500':
            case 'Turf Pro 500S':
                this.mowerImage = 'tp-turf-pro-500.png';
                break;

            case 'TM-850':
                this.mowerImage = 'tp-turf-mower-850.png';
                break;

            case 'TM-1050':
                this.mowerImage = 'tp-turf-mower-1050.png';
                break;

            case 'TM-2050':
                this.mowerImage = 'tp-turf-mower-2050.png';
                break;

            case 'Range Pro 100':
                this.mowerImage = 'tp-range-pro-100.png';
                break;

            default:
                this.mowerImage = 'turf-pro-mower.svg'
        }
    }
}
